import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SectorList from './SectorList';
import SectorForm from './SectorForm';

const SectorRoutes = () => {
  return (
    <Routes>
      <Route index element={<SectorList />} />
      <Route path="new" element={<SectorForm />} />
      <Route path="edit/:id" element={<SectorForm />} />
    </Routes>
  );
};

export default SectorRoutes; 